import PropTypes from "prop-types"
import { Button as MuiButton } from "@mui/material"
import OPTooltip from "../tooltip"

/*
 * The Material UI Button component with a tooltip.
 * @param {Object} props - The props for the button (same as MuiButton).
 * @param {React.ReactNode} props.children - The children of the button.
 * @param {string} props.tooltip - The tooltip text of the button.
 */
export default function Button({ children, tooltip, ...props }) {
  const button = <MuiButton {...props}>{children}</MuiButton>

  if (tooltip) {
    return <OPTooltip title={tooltip}><span>{button}</span></OPTooltip>
  }

  return button
}

Button.propTypes = {
  tooltip: PropTypes.string,
}
